import React from "react";
import { withStyles } from "@material-ui/core";
import DropYardViewCard from "./DropYardViewCard";
import DropYardEditCard from "./DropYardEditCard";
import drawConstant from "../../../../../common/DrawTools/DrawConstant";
import Events from "../../../../../../../../utilities/EventEmitter";

const styles = (theme) => ({
  title: {
    textTransform: "uppercase",
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    fontWeight: 600,
    marginBottom: 8,
  },
  cardContainer: {
    borderRadius: "8px",
    padding: "16px",
    cursor: "pointer",
    boxShadow: `0px 0px 4px 0px ${theme.tooltipShadowColor}`,
  },
  activeCard: {
    border: `2px solid ${theme.HeaderSelectedText}`,
    boxShadow: "none",
  },
});

const DropYardCard = ({
  classes,
  dropYard,
  isNewDropYard,
  cancelNewDropYard,
  activeDropYardId,
  setActiveDropYardId,
  isEditInProgress,
  setIsEditInProgress,
  dropYardClickedOnMap,
  handleSaveRegion,
  handleDeleteRegion,
  initialBoundary,
  resetInitialBoundary,
}) => {
  const enableEdit = () => {
    if (isEditInProgress) return;
    const { dropYardId } = dropYard;
    setIsEditInProgress(true);
    setActiveDropYardId(dropYardId);
    selectPolygonsOnMap(dropYardId, true);
  };

  const disableEdit = () => {
    setIsEditInProgress(false);
    setActiveDropYardId(null);
    if (isNewDropYard) {
      cancelNewDropYard();
    }
  };

  const selectPolygonsOnMap = (dropYardId, isEditMode = false) => {
    Events.emit(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_SELECTED_ON_SIDE_PANEL,
      [dropYardId],
      isEditMode
    );
  };

  const handleCardSelection = () => {
    if (isEditInProgress) return;
    const { dropYardId } = dropYard;
    selectPolygonsOnMap(dropYardId);
    setActiveDropYardId(dropYardId);
    dropYardClickedOnMap({ data: dropYard });
  };

  const isEditMode =
    activeDropYardId === dropYard?.dropYardId && isEditInProgress;

  return (
    <div>
      {isEditMode && (
        <div className={classes.title}>{`${
          isNewDropYard ? "New" : "Update"
        } Region`}</div>
      )}
      <div
        key={dropYard.dropYardId}
        className={`${classes.cardContainer} ${
          activeDropYardId === dropYard.dropYardId ? classes.activeCard : ""
        }`}
        onClick={handleCardSelection}
      >
        {isEditMode ? (
          <DropYardEditCard
            dropYard={dropYard}
            disableEdit={disableEdit}
            isNewDropYard={isNewDropYard}
            handleSaveRegion={handleSaveRegion}
            initialBoundary={initialBoundary}
            resetInitialBoundary={resetInitialBoundary}
          />
        ) : (
          <DropYardViewCard
            dropYard={dropYard}
            enableEdit={enableEdit}
            handleDeleteRegion={handleDeleteRegion}
          />
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(DropYardCard);
